import { Button, Card, CardContent, CardHeader, CardTitle } from '@ibsys/kit';
import { SettingsIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useHasPermission } from '@/entities/profile';

/**
 * Дополнительный блок на карточке интеграции анонимизатора.
 *
 * Даёт переход на страницу настройки конфигурации анонимизатора —
 * аналог BitrixCallsSection, но вместо встроенной таблицы ведёт на отдельную страницу.
 */
export const AnonymizerSection: FC = () => {
  const { t } = useTranslation(['integrations', 'common']);
  const navigate = useNavigate();
  // Same rights as the config page route: without them the link would lead to "Page not found",
  // and without the link the block has nothing to offer
  const canOpenConfig = useHasPermission(['VIEW_ANONYMIZE_CONFIG', 'ADMIN_ANONYMIZE_CONFIG']);

  const handleOpenConfig = () => {
    navigate('/anonymizer-config');
  };

  if (!canOpenConfig) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-xl">{t('integrations:anonymizer.title')}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-3">
        <p className="text-sm text-muted-foreground">{t('integrations:anonymizer.description')}</p>
        <Button type="button" onClick={handleOpenConfig} className="self-start">
          <SettingsIcon className="size-4" />
          {t('integrations:anonymizer.openConfig')}
        </Button>
      </CardContent>
    </Card>
  );
};
